import type { IFilterQuery } from '@shared';
import type {
  IAdsSubchapter,
  IAdsSubchapterPageableResponseData,
} from '@shared/ads-subchapter';

const ENDPOINT_PREFIX = 'ads-subchapter';

export const useAdsSubChapterStore = defineStore('ads-subchapter', () => {
  const apiClient = useApiClient();
  const adsSubChapters = ref<IAdsSubchapter[]>([]);
  const adsSubChapter = ref<IAdsSubchapter | null>(null);
  const { setItem, getItem } = useLocalStorage();

  const filter = async (payload?: IFilterQuery) => {
    if (!payload) payload = { page: 1, limit: 1000 };
    const result = await apiClient.post<
      IFilterQuery,
      IAdsSubchapterPageableResponseData
    >(ENDPOINT_PREFIX + '/filter', payload);
    if (result.success)
      adsSubChapters.value = result.data?.data as IAdsSubchapter[];
    return result;
  };

  const setSubChapter = (type: IAdsSubchapter) => {
      setItem('subcategory', type);
      adsSubChapter.value = type;
      return type;
  };

  const initSubChapter = () => {
      adsSubChapter.value = getItem('subcategory');
  };

  const clearSubChapters = () => {
    adsSubChapters.value = [];
  }

  return {
    filter,
    adsSubChapters,
    setSubChapter,
    initSubChapter,
    adsSubChapter,
    clearSubChapters,
  };
});
